import { render, staticRenderFns } from "./VerificationEmail.vue?vue&type=template&id=0ba36cf9&"
import script from "./VerificationEmail.vue?vue&type=script&lang=js&"
export * from "./VerificationEmail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports